import React, { useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { LicenseManager } from "ag-grid-enterprise";
import GlobalState from "../../context/GlobalState";
import Cookies from "js-cookie";
import Header from "../Header/Header";
import PublicHeader from "../PublicHeader/PublicHeader";
import DocumentLibraryContainer from "../DocumentLibrary/DocumentLibraryContainer";
import PageNotFound from "./PageNotFound";
import * as Constants from "../../constants/Constants";
import { httpGetPublicUIEnv } from "../../service/httpClient";

const PublicRoutes = (props, ...rest) => {
  const [isLoading, setIsLoading] = useState(true);
  const getPublicEnv = () => {
    return httpGetPublicUIEnv()
      .then((res) => {
        LicenseManager.setLicenseKey(res.data.AGGRID_LICENSE_KEY);
        return res.data;
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getPublicEnv()
      .then((uiEnv) => {
        if (uiEnv !== "undefined") {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log("Unable to get config details.");
      });
  }, []);

  const verifyMenuItemAccess = (navId) => {
    if (navId === "document-library") {
      return Constants.ENABLE_DOC_LIBRARY === "D" ? false : true;
    }
    return true;
  };

  return (
    <div>
      {isLoading ? (
        <Spinner
          animation="border"
          variant="danger"
          style={{
            width: "50px",
            height: "50px",
            marginRight: 5,
            position: "absolute",
            top: "40vh",
            left: "50vw",
          }}
        />
      ) : (
        <div>
          {Cookies.get("userName") ? (
            <GlobalState>
              <Header />
            </GlobalState>
          ) : (
            <PublicHeader />
          )}
          <Switch>
            <Route
              {...rest}
              exact
              path="/document-library"
              component={(props) => {
                return verifyMenuItemAccess("document-library") ? (
                  <DocumentLibraryContainer />
                ) : (
                  <PageNotFound />
                );
              }}
            />
          </Switch>
        </div>
      )}
    </div>
  );
};

export default PublicRoutes;
